import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step4', 'Steps', {
	data() {
		return {
			step4: null,
			selectedDoorType: 0,
			selectedDoorContruction: null,
			isKnowCanvasSize: 1,
			sizeRadioOptions: [
				{ label: 'Да', value: 1 },
				{ label: 'Нет', value: 0 },
			],
			appertureSelectedHeight: null,
			appertureSelectedWidth: null,
			appertureSelectedThick: null,
			doorCanvasWidth: 0,
			doorCanvasHeight: 0,
			doorCanvasThickness: 0,
			additionalCanvasWidth: 0,
			additionalCanvasHeight: 0,
		};
	},
	props: ['doorTypeApertureHeight', 'doorTypeApertureWidth', 'doorTypeApertureThick', 'door', 'edgeMilling'],
	methods: {
		calculatePrice: function () {
			const context = this;
			const nacenka = this.step4.nacenka.filter((item) => {
				if (item.width === Number(context.doorCanvasWidth.toString()) && item.height === Number(context.doorCanvasHeight.toString())) return item;
			});
			if (!nacenka.length) {
				return this.deletePositionKey(['doorSizePrice']);
			}
			this.deletePositionKey(['doorSizePrice']);

			let currentPrice = this.$store.state.positionPrice;
			let priceWithNacenka = currentPrice * nacenka[0].price;
			this.setPropPosition({
				doorSizePrice: { price: Math.floor(priceWithNacenka) },
			});
		},
		isDataStep: function () {
			return this.step4;
		},
		getDataStep: function () {
			let context = this;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep4', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
					positionPrice: this.$store.state.positionPrice,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step4 = response.data.result;
					context.isKnowCanvasSize = 1;
					const selectedValue = context.sizeRadioOptions.filter((item) => {
						if (item.value === context.isKnowCanvasSize) return item;
					})[0];

					context.setPropPosition({
						doorType: {
							id: this.step4.sashs[this.selectedDoorType].id,
							title: this.step4.sashs[this.selectedDoorType].title,
							image: this.step4.sashs[this.selectedDoorType].image,
							price: 0,
						},
						doorTypeKnownSize: selectedValue,
						doorTypeCanvasThickness: Number(context.step4.canvasThickness[0].value.toString().replace(/[+D]/gi, '')),
						doorTypeCanvasHeight: Number(context.step4.canvasHeight[0].value.toString().replace(/[+D]/gi, '')),
						doorTypeCanvasWidth: Number(context.step4.canvasWidth[0].value.toString().replace(/[+D]/gi, '')),
					});
				}
			});
		},
		setDoorType(point) {
			this.selectedDoorType = point;
			if (this.step4.sashs[this.selectedDoorType].construction !== undefined) {
				this.selectedDoorContruction = 0;
			} else {
				this.selectedDoorContruction = null;
			}
			this.changeTwoKnownSize();
		},
		setCanvasSizeChoise(value) {
			this.isKnowCanvasSize = value;
		},
		changeTwoKnownSize() {
			if (this.selectedDoorType === 1) {
				this.additionalCanvasHeight = this.doorCanvasHeight;

				if (this.selectedDoorContruction === 0 || this.selectedDoorContruction === 1) {
					const validVal = this.step4.apertureWidthTwo.filter((item) => {
						if (item.sim_value === this.doorCanvasWidth) return item;
					});
					if (!validVal.length) {
						this.additionalCanvasWidth = 0;
						return;
					}
					this.additionalCanvasWidth = validVal[0].sim_value;
				} else if (this.selectedDoorContruction === 2) {
					const validVal = this.step4.apertureWidthTwo.filter((item) => {
						if (item.value === this.doorCanvasWidth) return item;
					});
					if (!validVal.length) {
						this.additionalCanvasWidth = 0;
						return;
					}
					this.additionalCanvasWidth = validVal[0].dop_value;
				} else if (this.selectedDoorContruction === 3) {
					const validVal = this.step4.apertureWidthTwo.filter((item) => {
						if (item.dop_value === this.doorCanvasWidth) return item;
					});
					if (!validVal.length) {
						this.additionalCanvasWidth = 0;
						return;
					}
					this.additionalCanvasWidth = validVal[0].value;
				}
			} else {
				this.additionalCanvasHeight = null;
				this.additionalCanvasWidth = null;
			}
		},
		changeUnknowCanvasSize() {
			if (this.selectedDoorContruction === null && !this.isKnowCanvasSize) {
				this.doorCanvasHeight = 0;
				this.doorCanvasWidth = 0;
				this.additionalCanvasHeight = 0;
				this.additionalCanvasWidth = 0;
			}

			if (this.isKnowCanvasSize) return;
			if (this.selectedDoorType === 1) {
				const appertureHeight = this.step4.apertureHeight.filter((item) => {
					if (item.label === this.appertureSelectedHeight) return item;
				})[0].value;
				this.doorCanvasHeight = appertureHeight;
				this.additionalCanvasHeight = appertureHeight;
				if (this.selectedDoorContruction === 0 || this.selectedDoorContruction === 1) {
					const simValue = this.step4.apertureWidthTwo.filter((item) => {
						if (item.label === this.appertureSelectedWidth) return item;
					});
					if (!simValue.length) return;
					this.doorCanvasWidth = simValue[0].sim_value;
					this.additionalCanvasWidth = simValue[0].sim_value;
				} else if (this.selectedDoorContruction === 2) {
					const aSimValue = this.step4.apertureWidthTwo.filter((item) => {
						if (item.label === this.appertureSelectedWidth) return item;
					})[0].value;
					const aSimDopValue = this.step4.apertureWidthTwo.filter((item) => {
						if (item.label === this.appertureSelectedWidth) return item;
					})[0].dop_value;
					this.doorCanvasWidth = aSimValue;
					this.additionalCanvasWidth = aSimDopValue;
				} else if (this.selectedDoorContruction === 3) {
					const aSimValue = this.step4.apertureWidthTwo.filter((item) => {
						if (item.label === this.appertureSelectedWidth) return item;
					})[0].dop_value;
					const aSimDopValue = this.step4.apertureWidthTwo.filter((item) => {
						if (item.label === this.appertureSelectedWidth) return item;
					})[0].value;
					this.doorCanvasWidth = aSimValue;
					this.additionalCanvasWidth = aSimDopValue;
				}
			}

			// this.storeCalculatePrice();
		},
		setAppertureValue(field, value) {
			switch (field) {
				case 0:
					this.appertureSelectedHeight = this.step4.apertureHeight.filter((item) => {
						if (item.value === value) return item;
					})[0].label;
					if (this.selectedDoorContruction !== null) {
						this.doorCanvasHeight = value;
						this.additionalCanvasHeight = value;
					} else {
						this.doorCanvasHeight = value;
						this.additionalCanvasHeight = null;
					}
					break;
				case 1:
					if (this.selectedDoorType === 0) {
						this.appertureSelectedWidth = this.step4.apertureWidth.filter((item) => {
							if (item.value === value) return item;
						})[0].label;
					} else {
						this.appertureSelectedWidth = this.step4.apertureWidthTwo.filter((item) => {
							if (item.label === value) return item;
						})[0].label;
					}

					if (this.selectedDoorContruction !== null) {
						this.changeUnknowCanvasSize();
					} else {
						this.doorCanvasWidth = value;
						this.additionalCanvasWidth = null;
					}
					break;
				case 2:
					this.appertureSelectedThick = value;
					break;
			}
			// this.storeCalculatePrice();
		},
		resetProps() {
			if (this.isKnowCanvasSize === null || this.isKnowCanvasSize === undefined) return;

			const selectedValue = this.sizeRadioOptions.filter((item) => {
				if (item.value === this.isKnowCanvasSize) return item;
			})[0];

			const sashs = this.step4.sashs;

			if (selectedValue.value) {
				if (sashs[this.selectedDoorType].title === 'Одностворчатая') {
					this.setPropPosition({ doorTypeAdditionalCanvasHeight: null, doorTypeAdditionalCanvasWidth: null });
					this.setPropPosition({});
				}
				this.setPropPosition({ doorTypeApertureHeight: null, doorTypeApertureWidth: null, doorTypeApertureThick: null });
			} else {
				if (sashs[this.selectedDoorType].title === 'Одностворчатая') {
					this.setPropPosition({ doorTypeAdditionalCanvasHeight: null, doorTypeAdditionalCanvasWidth: null });
				}

				this.setPropPosition({
					doorTypeApertureHeight: this.appertureSelectedHeight,
				});
				this.setPropPosition({
					doorTypeApertureWidth: this.appertureSelectedWidth,
				});
				this.setPropPosition({
					doorTypeApertureThick: this.appertureSelectedThick,
				});
			}
		},
	},
	created: function () {
		this.getDataStep();
	},
	watch: {
		edgeMilling(val, oldValue) {
			if (val !== undefined && val !== null && oldValue !== null) {
				if (Number(val.id) !== Number(oldValue.id)) {
					this.getDataStep();
				}
			}
		},
		selectedDoorType(val) {
			let price = 0;
			if (this.step4.sashs[val].title.trim().toLowerCase() === 'двухстворчатая') {
				price = this.door.price;
			}

			this.setPropPosition({
				doorType: {
					id: this.step4.sashs[val].id,
					title: this.step4.sashs[val].title,
					image: this.step4.sashs[val].image,
					price: price,
				},
			});

			// if (val === 1) {
			// this.selectedDoorContruction = 0;
			// this.setPropPosition({
			// doorTypeConstruction: this.step4.sashs[val].construction[0],
			// });
			// } else {
			// this.selectedDoorContruction = null;
			// this.setPropPosition({
			// doorTypeConstruction: null,
			// });
			// }

			this.resetProps();
		},
		selectedDoorContruction(val) {
			if (val !== null) {
				this.setPropPosition({
					doorTypeConstruction: this.step4.sashs[this.selectedDoorType].construction[val],
				});

				this.changeUnknowCanvasSize();
				this.changeTwoKnownSize();
			} else {
				this.setPropPosition({ doorTypeConstruction: null });
			}
		},
		isKnowCanvasSize(val) {
			if (val !== null) {
				const selectedValue = this.sizeRadioOptions.filter((item) => {
					if (item.value === val) return item;
				})[0];
				this.setPropPosition({ doorTypeKnownSize: selectedValue });
				this.resetProps();
			} else {
				this.setPropPosition({ doorTypeKnownSize: null });
			}
		},
		appertureSelectedHeight(val) {
			if (this.isKnowCanvasSize !== null && !this.isKnowCanvasSize) {
				this.setPropPosition({ doorTypeApertureHeight: val });
			} else {
				this.setPropPosition({ doorTypeApertureHeight: null });
			}
		},

		appertureSelectedWidth(val) {
			if (this.isKnowCanvasSize !== null && !this.isKnowCanvasSize) {
				this.setPropPosition({ doorTypeApertureWidth: val });
			} else {
				this.setPropPosition({ doorTypeApertureWidth: null });
			}
		},
		appertureSelectedThick(val) {
			if (this.isKnowCanvasSize !== null && !this.isKnowCanvasSize) {
				this.setPropPosition({ doorTypeApertureThick: val });
			} else {
				this.setPropPosition({ doorTypeApertureThick: null });
			}
		},
		doorCanvasThickness(val) {
			if (this.isKnowCanvasSize !== null && this.isKnowCanvasSize) {
				this.setPropPosition({ doorTypeCanvasThickness: Number(val.toString().replace(/[+D]/gi, '')), forNacenka: this.step4.nacenka });
			} else {
				this.setPropPosition({ doorTypeCanvasThickness: null });
			}
		},
		doorCanvasHeight(val) {
			this.setPropPosition({ doorTypeCanvasHeight: Number(val.toString().replace(/[+D]/gi, '')), forNacenka: this.step4.nacenka });
			// this.storeCalculatePrice();
		},
		doorCanvasWidth(val) {
			this.setPropPosition({ doorTypeCanvasWidth: Number(val.toString().replace(/[+D]/gi, '')), forNacenka: this.step4.nacenka });
			// this.storeCalculatePrice();
		},
		additionalCanvasHeight(val) {
			this.setPropPosition({ doorTypeAdditionalCanvasHeight: Number(val.toString().replace(/[+D]/gi, '')), forNacenka: this.step4.nacenka });
			// this.storeCalculatePrice();
		},
		additionalCanvasWidth(val) {
			this.setPropPosition({ doorTypeAdditionalCanvasWidth: Number(val.toString().replace(/[+D]/gi, '')), forNacenka: this.step4.nacenka });
			// this.storeCalculatePrice();
		},
	},
	template: `
<div class="config-block">
	<div v-if="isDataStep()">
		<div class="config-block__wrap">
			<div class="config-block__wrap-title">Тип двери</div>
			<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="2">
				<div class="swiper-slide" v-for="(slide, index) of step4.sashs">
					<SimpleItemTop :image="slide.image" :title="slide.title" :key="index"
						:class="{active: selectedDoorType === index}" v-on:setActive="setDoorType(index)" />
				</div>
			</Swiper>
		</div>
		<div class="config-block__inner" v-if="selectedDoorType!==null">
			<div class="config-block__wrap mt-48"
				v-if="selectedDoorType !== null && step4.sashs[selectedDoorType].construction">
				<div class="config-block__wrap-title">Конструкция</div>
				<Swiper :basicSlidesPerView="2" :basicSpaceBetween="20" :breakpointsForSlides="4">
					<div class="swiper-slide" v-for="(slide, index) of step4.sashs[selectedDoorType].construction">
						<SimpleItemTop :image="slide.image" :title="slide.title" :price="slide.price" :priceType="2" :key="index"
							:class="{active: selectedDoorContruction === index}" v-on:setActive="selectedDoorContruction = index" />
					</div>
				</Swiper>
			</div>
			<div class="config-block__wrap mt-48">
				<div class="config-block__wrap-title">Знаю размер полотна</div>
				<RadioGroup :options="sizeRadioOptions" :selected="sizeRadioOptions[0].value" name="canvas_size"
					v-on:selectedValue="setCanvasSizeChoise" />
			</div>
			<div class="config-block__wrap mt-48" v-if="!isKnowCanvasSize">
				<div class="config-block__wrap-title">Размер проема</div>
				<div class="flex config-row__door-params">
					<Select class="mb-15 minw600:mr-15 minw1100:mr-20" label="Высота" :options="step4.apertureHeight"
						:selected="step4.apertureHeight[0]" v-on:selectSelectedValue="setAppertureValue(0,$event.value)" />
					<Select class="mb-15 minw600:mr-15 minw1100:mr-20" label="Ширина" :options="step4.apertureWidth"
						:selected="step4.apertureWidth[0]" v-on:selectSelectedValue="setAppertureValue(1,$event.value)"
						v-if="selectedDoorType===0" :watchingData="selectedDoorType" />
					<Select class="mb-15 minw600:mr-15 minw1100:mr-20" label="Ширина" :options="step4.apertureWidthTwo"
						:selected="step4.apertureWidthTwo[0]" v-on:selectSelectedValue="setAppertureValue(1,$event.label)"
						v-if="selectedDoorType===1" :watchingData="selectedDoorType" />
					<Select class="mb-15 minw600:mr-15 minw1100:mr-20" label="Толщина стены" :options="step4.apertureThickness"
						:selected="step4.apertureThickness[0]" v-on:selectSelectedValue="setAppertureValue(2,$event.value)" />
				</div>
			</div>
			<div class="config-block__inner mt-48" v-if="selectedDoorType===0">
				<div class="config-block__wrap-title">Размер полотна</div>
				<div class="config-block__wrap grid grid-cols-1 sm:grid-cols-3 gap-15 sm:gap-20" v-if="isKnowCanvasSize">
					<Select label="Высота" :options="step4.canvasHeight" :selected="step4.canvasHeight[0]"
						v-on:selectSelectedValue="doorCanvasHeight = $event.value" :watchingData="selectedDoorType" />
					<Select label="Ширина" :options="step4.canvasWidth" :selected="step4.canvasWidth[0]"
						v-on:selectSelectedValue="doorCanvasWidth = $event.value" :watchingData="selectedDoorType" />
					<Select label="Толщина стены" v-if="step4.canvasThickness" :options="step4.canvasThickness" :selected="step4.canvasThickness[0]"
						v-on:selectSelectedValue="doorCanvasThickness = $event.value" :watchingData="selectedDoorType" />
				</div>
				<div class="config-block__wrap grid grid-cols-1 sm:grid-cols-3 gap-15 sm:gap-20" v-else>
					<InputDisabled :value="doorCanvasHeight + ' мм'" name="canvas_height" label="Высота"
						:watchingData="isKnowCanvasSize" />
					<InputDisabled :value="doorCanvasWidth + ' мм'" name="canvas_width" label="Ширина"
						:watchingData="isKnowCanvasSize" />
				</div>
			</div>
			<div class="config-block__inner mt-48" v-else-if="selectedDoorType===1">
				<div class="config-block__wrap-title">Размер полотна</div>
				<div class="config-block__wrap" v-if="isKnowCanvasSize">
					<div class="config-block__inner">
						<div class="config-block__title-2">Активная створка</div>
						<div class="config-block__wrap grid grid-cols-1 sm:grid-cols-3 gap-15 sm:gap-20 mt-20">
							<Select label="Высота" :options="step4.canvasHeight" :selected="step4.canvasHeight[0]"
								v-on:selectSelectedValue="doorCanvasHeight = $event.value, changeTwoKnownSize()" :watchingData="isKnowCanvasSize" />
							<Select label="Ширина" :options="step4.canvasWidth" :selected="step4.canvasWidth[0]"
								v-on:selectSelectedValue="doorCanvasWidth = $event.value, changeTwoKnownSize()" :watchingData="isKnowCanvasSize" />
							<Select label="Толщина стены" v-if="step4.canvasThickness" :options="step4.canvasThickness" :selected="step4.canvasThickness[0]" v-on:selectSelectedValue="doorCanvasThickness = $event.value" :watchingData="selectedDoorType" />
						</div>
					</div>
					<div class="config-block__inner mt-48">
						<div class="config-block__title-2">Дополнительная створка</div>
						<div class="config-block__wrap grid grid-cols-1 sm:grid-cols-3 gap-15 sm:gap-20 mt-20">
							<InputDisabled :value="additionalCanvasHeight + ' мм'" name="canvas_height" label="Высота"
								:watchingData="isKnowCanvasSize" />
							<InputDisabled :value="additionalCanvasWidth + ' мм'" name="canvas_width" label="Ширина"
								:watchingData="isKnowCanvasSize" />
							<!--<Select label="Высота" :options="step4.canvasHeight" :selected="step4.canvasHeight[0]"
								v-on:selectSelectedValue="doorCanvasHeight = $event.value, changeTwoKnownSize()" :watchingData="isKnowCanvasSize" />
							<Select label="Ширина" :options="step4.canvasWidth" :selected="step4.canvasWidth[0]"
								v-on:selectSelectedValue="doorCanvasWidth = $event.value, changeTwoKnownSize()" :watchingData="isKnowCanvasSize" />-->
						</div>
					</div>
				</div>
				<div class="config-block__wrap" v-else>
					<div class="config-block__inner">
						<div class="config-block__title-2">Активная створка</div>
						<div class="config-block__wrap grid grid-cols-1 sm:grid-cols-3 gap-15 sm:gap-20 mt-20">
							<InputDisabled :value="doorCanvasHeight + ' мм'" name="canvas_height" label="Высота"
								:watchingData="isKnowCanvasSize" />
							<InputDisabled :value="doorCanvasWidth + ' мм'" name="canvas_width" label="Ширина"
								:watchingData="isKnowCanvasSize" />
						</div>
					</div>
					<div class="config-block__inner mt-48">
						<div class="config-block__title-2">Дополнительная створка</div>
						<div class="config-block__wrap grid grid-cols-1 sm:grid-cols-3 gap-15 sm:gap-20 mt-20">
							<InputDisabled :value="additionalCanvasHeight + ' мм'" name="canvas_height" label="Высота"
								:watchingData="isKnowCanvasSize" />
							<InputDisabled :value="additionalCanvasWidth + ' мм'" name="canvas_width" label="Ширина"
								:watchingData="isKnowCanvasSize" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else>
		<div class="config-block__wrap-title">Тип двери</div>
		<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="2">
			<div class="swiper-slide" v-for="i of [1,2]">
				<PuSkeleton height="200px" />
			</div>
		</Swiper>
	</div>
</div>
`,
});
